import type { ChargeDecisionRequestBody, ChargeRequestBody } from './models';

export const mapChargeRequestBody = (attrs: ChargeRequestBody) => {
  const {
    captchaResponse,
    cardClassification,
    cardCountry,
    cardProductType,
    confirmURL,
    orderId,
    orderToken,
    sessionId,
    isFromGateway,
  } = attrs;

  return {
    api_confirmation_url: confirmURL,
    captcha_response: captchaResponse,
    card: {
      classification: cardClassification,
      country: cardCountry,
      product_type: cardProductType,
    },
    order: {
      id: orderId,
      token: orderToken,
    },
    session_id: sessionId,
    is_from_gateway: isFromGateway,
  };
};

export const mapChargeDecisionRequestBody = (
  attrs: ChargeDecisionRequestBody,
) => {
  const {
    cardClassification,
    cardCountry,
    cardProductType,
    orderId,
    orderToken,
  } = attrs;

  return {
    card: {
      classification: cardClassification,
      country: cardCountry,
      product_type: cardProductType,
    },
    order: {
      id: orderId,
      token: orderToken,
    },
  };
};
